<template>
    <Btn
        active-color="primary"
        v-bind="$attrs"
        :active="active"
        :left-icon="active ? 'bell-full' : 'bell'"
        class="btn-follow"
    />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

/**
 * Simple button indicating a follow action
 */
export default defineComponent({
    name: 'BtnFollow',
    inheritAttrs: false,
    props: {
        /**
         * toggles between a following and unfollowing state
         */
        active: {
            type: Boolean,
            default: false,
        },
    },
});
</script>

<style lang="scss" scoped>
.btn-follow:not(.disabled):deep(.btn-icon) {
    @apply transition-colors duration-300 ease-in-out;

    &:hover,
    &:focus {
        animation: shake 0.5s ease-in-out;
    }
}
</style>
